import React, { useState } from 'react';
import FilterSideBar from './filterSideBar/filterSideBar';
import CurvedProgressBar from './processbar/CurvedProgressBar';
import ImportMediaDialog from './importMediaFolder/importMediaDialog';

import {
    Modal,
    ModalBody,
    ModalHeader,
} from "reactstrap";

function Storage({ spaceLimit, inputRef, totalSize, docSize, imageSize, audioSize, nassubdata, folderStructure }) {
    console.log(spaceLimit, " : spaceLimit")
    console.log(totalSize," : total Size")
    const [modalimportopen, setModalImportOpen] = useState(false);
    const [uploadingLoader, setUploadingLoader] = useState(false)
    const [showPicker, setShowPicker] = useState(false)
    const userRole = localStorage.getItem("CloudUserType")
    function formatBytes(bytes) {
        if (bytes === 0) return '0 Bytes';

        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        const i = Math.floor(Math.log(bytes) / Math.log(1024));
        const value = bytes / Math.pow(1024, i);

        return `${value.toFixed(2)} ${sizes[i]}`;
    }

    const storage = {
        used: 5,
        total: formatBytes(totalSize),
        categories: {
            Documents: { size: `${formatBytes(docSize)}`, files: 194, icon: "fa fa-file-text" },
            Photos: { size: `${formatBytes(imageSize)}`, files: 2138, icon: "fa fa-picture-o" },
            Musics: { size: `${formatBytes(audioSize)}`, files: 424, icon: "fa fa-music" },
        }
    };


    const openImportfiles = () => {
        setModalImportOpen(true);
    };
    const toggleModal = () => {
        setModalImportOpen(!modalimportopen);
        inputRef()
    }

    const colorEndDay = () => {
        const currentDate = new Date();
        const endDate = new Date(nassubdata.endDateNas);
        const timeDiff = endDate - currentDate;
        const daysRemaining = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));

        if (daysRemaining <= 10) {
            // Interpolate color between light red and dark red as days decrease
            const redIntensity = Math.min(225, 225 - ((11 - daysRemaining) * 20));
            console.log(redIntensity)
            return < div style={{ color: `rgb(255, ${redIntensity}, ${redIntensity})` }}>Subscription ending in {daysRemaining} day </div>

        }
        return < div style={{ color: "black" }}>Subscription ending in  {daysRemaining} day</div>
    }
    return (
        <>
            <div className="storage-section">
                <div>
                    <div >
                        <div className='storagehead'><div className="storage">Storage</div>
                            {userRole !== "property_user" && <div className="storage1">{colorEndDay()}</div>}
                        </div>
                        <div className="processBar">

                            <CurvedProgressBar usedSize={formatBytes(totalSize)} totalSize={`${spaceLimit}000 MB`} strokeWidth={20} radius={100} color="#0398fc" >helo</CurvedProgressBar>
                        </div>
                    </div>
                    <FilterSideBar props={storage} />
                </div>
                <div className='upload-file' onClick={openImportfiles} >
                    <button className="btn "><i className="fa fa-cloud-upload btn4 mr-2"  > </i> Import Files</button>
                    <Modal isOpen={modalimportopen}>
                        <ModalHeader><strong>Import Files</strong></ModalHeader>
                        <ModalBody>
                            <ImportMediaDialog folderStructure={folderStructure} onClose={toggleModal} setShowPicker={setShowPicker} uploadingLoader={uploadingLoader} setUploadingLoader={setUploadingLoader} storage={totalSize} />
                        </ModalBody>
                    </Modal>
                </div>

            </div>
        </>
    )
}

export default Storage